// ============================================================
// Gün dönümü nöbetçisi
//
// BUGUN bir modül sabiti: uygulama açıldığı andaki tarihi taşıyor.
// Kreşte tablet sabahtan akşama, çoğu zaman da gece boyunca açık
// kalıyor. Gece yarısını geçtiğinde sabit eskiyor ve ertesi sabahki
// yoklama DÜNE yazılıyor — sessiz ve fark edilmesi zor bir bozulma.
//
// BUGUN'u fonksiyona çevirmek otuz dosyayı değiştirmek demekti;
// bunun yerine gün değişince uygulamayı yeniden yüklüyoruz. Yeniden
// yükleme veri kaybettirmez: her yazma zaten depoya gitmiş durumda.
// ============================================================

import { BUGUN, bugunuHesapla, firebaseHazir } from "../config.js";

const DAKIKA = 60 * 1000;

/**
 * Uygulamanın açıldığı gün geçti mi?
 *
 * Saf ve dışa açık: nöbetçinin kendisi zamanlayıcı ve tarayıcı
 * olaylarıyla uğraştığı için doğrudan test edilmesi zor, asıl karar
 * ise bu tek satır.
 */
export const gunDegisti = (baslangicGunu = BUGUN) =>
  bugunuHesapla() !== baslangicGunu;

/**
 * @param {() => void} [yenidenYukle] test için enjekte edilir
 * @returns {() => void} izlemeyi bırakır
 */
export function gunDegisiminiIzle(yenidenYukle = () => location.reload()) {
  // Demo günü sabit; orada gün dönümü diye bir şey yok.
  if (!firebaseHazir) return () => {};

  const bak = () => {
    if (gunDegisti()) yenidenYukle();
  };

  // Sekme arka plandayken tarayıcılar zamanlayıcıyı kısıyor; asıl
  // güvendiğimiz şey sekmeye geri dönüldüğünde yapılan kontrol.
  const zamanlayici = setInterval(bak, DAKIKA);
  const gorunurlukte = () => { if (!document.hidden) bak(); };
  document.addEventListener("visibilitychange", gorunurlukte);

  return () => {
    clearInterval(zamanlayici);
    document.removeEventListener("visibilitychange", gorunurlukte);
  };
}
